window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.expand = 300;
window.lazySizesConfig.loadMode = 1;

window.theme = window.theme || {};

(function () {
	var moneyFormat = (window.theme.settings && window.theme.settings.moneyFormat) || '¥{{amount_no_decimals}}';

	function formatMoney(cents, format) {
		if (typeof cents === 'string') cents = cents.replace('.', '');
		var value = '';
		var placeholder = /\{\{\s*(\w+)\s*\}\}/;
		var fmt = format || moneyFormat;

		function defaultTo(num, precision, thousands, decimal) {
			thousands = thousands === undefined ? ',' : thousands;
			decimal = decimal === undefined ? '.' : decimal;
			if (isNaN(num) || num === null) return 0;
			num = (num / 100.0).toFixed(precision);
			var parts = num.split('.');
			var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
			var cents = parts[1] ? decimal + parts[1] : '';
			return dollars + cents;
		}

		switch ((fmt.match(placeholder) || [])[1]) {
			case 'amount':
				value = defaultTo(cents, 2);
				break;
			case 'amount_no_decimals':
				value = defaultTo(cents, 0);
				break;
			case 'amount_with_comma_separator':
				value = defaultTo(cents, 2, '.', ',');
				break;
			case 'amount_no_decimals_with_comma_separator':
				value = defaultTo(cents, 0, '.', ',');
				break;
			case 'amount_with_space_separator':
				value = defaultTo(cents, 2, ' ', ',');
				break;
			case 'amount_no_decimals_with_space_separator':
				value = defaultTo(cents, 0, ' ');
				break;
			default:
				value = defaultTo(cents, 2);
		}
		return fmt.replace(placeholder, value);
	}

	theme.formatMoney = formatMoney;

	function parseJSON(el) {
		if (!el) return null;
		try {
			return JSON.parse(el.textContent);
		} catch (e) {
			return null;
		}
	}

	function ProductSection(container) {
		this.container = container;
		this.variantsEl = container.querySelector('[data-variant-json]');
		this.variants = parseJSON(this.variantsEl);
		if (!this.variants) return;
		this.select = container.querySelector('[data-product-select]');
		this.form = container.querySelector('form[action*="/cart/add"]');
		this.init();
	}

	ProductSection.prototype.init = function () {
		var self = this;
		this.container.addEventListener('change', function (evt) {
			if (evt.target.matches('[data-variant-input]')) self.onOptionChange();
			if (evt.target.matches('[data-single-option-selector]')) self.onOptionChange();
		});
		this.onOptionChange(true);
	};

	ProductSection.prototype.selectedOptions = function () {
		var opts = [];
		var inputs = this.container.querySelectorAll('[data-variant-input]:checked');
		for (var i = 0; i < inputs.length; i++) {
			var idx = parseInt(String(inputs[i].getAttribute('data-index')).replace('option', ''), 10);
			opts[idx - 1] = inputs[i].value;
		}
		if (!opts.length) {
			var selects = this.container.querySelectorAll('select[data-index]');
			for (var j = 0; j < selects.length; j++) {
				var k = parseInt(String(selects[j].getAttribute('data-index')).replace('option', ''), 10);
				opts[k - 1] = selects[j].value;
			}
		}
		return opts;
	};

	ProductSection.prototype.matchVariant = function (opts) {
		if (!opts.length) return this.variants[0];
		for (var i = 0; i < this.variants.length; i++) {
			var v = this.variants[i];
			var ok = true;
			for (var j = 0; j < opts.length; j++) {
				if (opts[j] === undefined) continue;
				if (v.options[j] !== opts[j]) {
					ok = false;
					break;
				}
			}
			if (ok) return v;
		}
		return null;
	};

	ProductSection.prototype.onOptionChange = function (initial) {
		var variant = this.matchVariant(this.selectedOptions());
		this.currentVariant = variant;
		this.updateSelect(variant);
		this.updatePrice(variant);
		this.updateButton(variant);
		this.updateSku(variant);
		this.updateColorLabel();
		if (!initial) {
			this.updateMedia(variant);
			this.updateHistory(variant);
		}
		this.container.dispatchEvent(
			new CustomEvent('variantChange', { detail: { variant: variant }, bubbles: true })
		);
	};

	ProductSection.prototype.updateSelect = function (variant) {
		if (!this.select) return;
		this.select.value = variant ? variant.id : '';
		var hidden = this.container.querySelector('input[name="id"]');
		if (hidden && hidden !== this.select) hidden.value = variant ? variant.id : '';
	};

	ProductSection.prototype.updatePrice = function (variant) {
		var priceEl = this.container.querySelector('[data-product-price]');
		var compareEl = this.container.querySelector('[data-compare-price]');
		var compareWrap = this.container.querySelector('[data-product-price-wrap]');
		var saveEl = this.container.querySelector('[data-save-price]');
		var unitWrap = this.container.querySelector('[data-unit-price-wrapper]');
		var unitEl = this.container.querySelector('[data-unit-price]');

		if (!variant) {
			if (priceEl) priceEl.textContent = '';
			return;
		}
		if (priceEl) priceEl.innerHTML = formatMoney(variant.price);

		var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
		if (compareWrap) compareWrap.classList.toggle('hide', !onSale);
		if (compareEl) compareEl.innerHTML = onSale ? formatMoney(variant.compare_at_price) : '';
		if (priceEl) priceEl.classList.toggle('on-sale', !!onSale);
		if (saveEl) {
			saveEl.classList.toggle('hide', !onSale);
			if (onSale) saveEl.innerHTML = formatMoney(variant.compare_at_price - variant.price);
		}
		if (unitWrap) {
			var hasUnit = !!variant.unit_price_measurement;
			unitWrap.classList.toggle('hide', !hasUnit);
			if (hasUnit && unitEl) unitEl.innerHTML = formatMoney(variant.unit_price);
		}
	};

	ProductSection.prototype.updateButton = function (variant) {
		var btn = this.container.querySelector('[data-add-to-cart]');
		if (!btn) return;
		var textEl = this.container.querySelector('[data-add-to-cart-text]');
		var strings = window.theme.strings || {};
		if (!variant) {
			btn.setAttribute('disabled', 'disabled');
			if (textEl) textEl.textContent = strings.unavailable || 'Unavailable';
		} else if (variant.available) {
			btn.removeAttribute('disabled');
			if (textEl) textEl.textContent = textEl.getAttribute('data-default-text') || textEl.textContent;
		} else {
			btn.setAttribute('disabled', 'disabled');
			if (textEl) textEl.textContent = strings.soldOut || 'Sold out';
		}
	};

	ProductSection.prototype.updateSku = function (variant) {
		var skuEl = this.container.querySelector('[data-sku]');
		if (skuEl && variant) skuEl.textContent = variant.sku || '';
	};

	ProductSection.prototype.updateColorLabel = function () {
		var labels = this.container.querySelectorAll('[data-variant-color-label]');
		for (var i = 0; i < labels.length; i++) {
			var idx = labels[i].getAttribute('data-option-index');
			var checked = this.container.querySelector('[data-variant-input][data-index="option' + idx + '"]:checked');
			if (checked) labels[i].textContent = checked.value;
		}
	};

	ProductSection.prototype.updateMedia = function (variant) {
		if (!variant || !variant.featured_media) return;
		var id = variant.featured_media.id;
		var target = this.container.querySelector('[data-media-id="' + id + '"]');
		if (!target) {
			var all = this.container.querySelectorAll('[data-media-id]');
			for (var i = 0; i < all.length; i++) {
				if (String(all[i].getAttribute('data-media-id')).indexOf(String(id)) !== -1) {
					target = all[i];
					break;
				}
			}
		}
		if (!target) return;
		var siblings = target.parentNode.querySelectorAll('[data-media-id]');
		for (var j = 0; j < siblings.length; j++) siblings[j].classList.remove('is-active');
		target.classList.add('is-active');
		if (typeof target.scrollIntoView === 'function' && window.innerWidth < 750) {
			target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
		}
	};

	ProductSection.prototype.updateHistory = function (variant) {
		if (!variant || !history.replaceState) return;
		if (!this.container.hasAttribute('data-history')) return;
		var url = new URL(window.location.href);
		url.searchParams.set('variant', variant.id);
		history.replaceState({}, '', url.toString());
	};

	function cartCountEls() {
		return document.querySelectorAll('.cart-link__bubble-num, .cart-count-bubble span[aria-hidden], [data-cart-count]');
	}

	function updateCartCount(count) {
		var els = cartCountEls();
		for (var i = 0; i < els.length; i++) els[i].textContent = count;
		var bubbles = document.querySelectorAll('.cart-link__bubble');
		for (var j = 0; j < bubbles.length; j++) {
			bubbles[j].classList.toggle('cart-link__bubble--visible', count > 0);
		}
	}

	theme.updateCartCount = updateCartCount;

	var overlayEl = null;

	function getOverlay() {
		if (overlayEl) return overlayEl;
		overlayEl = document.createElement('div');
		overlayEl.className = 'san-drawer-overlay';
		overlayEl.addEventListener('click', closeDrawers);
		document.body.appendChild(overlayEl);
		return overlayEl;
	}

	function openDrawer(drawer) {
		if (!drawer) return;
		closeDrawers();
		drawer.classList.add('is-open');
		getOverlay().classList.add('is-visible');
		document.documentElement.classList.add('san-drawer-open');
	}

	function closeDrawers() {
		var open = document.querySelectorAll('.drawer.is-open');
		for (var i = 0; i < open.length; i++) open[i].classList.remove('is-open');
		if (overlayEl) overlayEl.classList.remove('is-visible');
		document.documentElement.classList.remove('san-drawer-open');
	}

	theme.openDrawer = openDrawer;
	theme.closeDrawers = closeDrawers;

	function escapeHtml(s) {
		return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
			return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
		});
	}

	function renderCartDrawer(cart) {
		var drawer = document.getElementById('CartDrawer');
		if (!drawer) return;
		var wrap = drawer.querySelector('[data-products]');
		var subtotal = drawer.querySelector('[data-subtotal]');
		if (subtotal) subtotal.innerHTML = formatMoney(cart.total_price);
		drawer.classList.toggle('is-empty', !cart.item_count);
		if (!wrap) return;
		var html = '';
		for (var i = 0; i < cart.items.length; i++) {
			var it = cart.items[i];
			var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/, '_240x$1$2') : '';
			html += '<div class="san-cart__item" data-line="' + (i + 1) + '" data-key="' + it.key + '">' +
				'<div class="san-cart__item-img"><a href="' + it.url + '">' + (img ? '<img src="' + img + '" alt="">' : '') + '</a></div>' +
				'<div class="san-cart__item-info">' +
				'<div class="san-cart__item-title"><a class="san-cart__item-name" href="' + it.url + '">' + escapeHtml(it.product_title) + '</a></div>' +
				(it.variant_title ? '<div class="san-cart__item-variant">' + escapeHtml(it.variant_title) + '</div>' : '') +
				(it.selling_plan_allocation ? '<div class="san-cart__item-variant">' + escapeHtml(it.selling_plan_allocation.selling_plan.name) + '</div>' : '') +
				'<div class="san-cart__item-sub">' +
				'<div class="js-qty__wrapper">' +
				'<button type="button" class="js-qty__adjust" data-qty-adjust data-qty-minus aria-label="-">&minus;</button>' +
				'<input type="number" class="js-qty__num" value="' + it.quantity + '" min="0" data-cart-line="' + (i + 1) + '">' +
				'<button type="button" class="js-qty__adjust" data-qty-adjust data-qty-plus aria-label="+">+</button>' +
				'</div>' +
				'<div class="san-cart__item-price">' +
				(it.original_line_price !== it.final_line_price
					? '<span class="san-cart__price san-cart__price--old">' + formatMoney(it.original_line_price) + '</span><span class="san-cart__price">' + formatMoney(it.final_line_price) + '</span>'
					: '<span class="san-cart__price">' + formatMoney(it.final_line_price) + '</span>') +
				'</div>' +
				'</div>' +
				'<a href="#" class="san-cart__remove" data-cart-remove data-cart-line="' + (i + 1) + '">' + (theme.strings.removeLabel || '削除') + '</a>' +
				'</div></div>';
		}
		wrap.innerHTML = html;
	}

	function fetchCart() {
		return fetch(window.Shopify.routes.root + 'cart.js')
			.then(function (r) { return r.json(); })
			.then(function (cart) {
				updateCartCount(cart.item_count);
				renderCartDrawer(cart);
				return cart;
			});
	}

	theme.fetchCart = fetchCart;

	function changeCartLine(line, quantity) {
		return fetch(window.Shopify.routes.root + 'cart/change.js', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
			body: JSON.stringify({ line: line, quantity: quantity })
		})
			.then(function (r) { return r.json(); })
			.then(function (cart) {
				updateCartCount(cart.item_count);
				renderCartDrawer(cart);
				return cart;
			});
	}

	document.addEventListener('click', function (evt) {
		var t = evt.target.closest && evt.target.closest('.js-drawer-open-cart');
		if (t && document.getElementById('CartDrawer')) {
			evt.preventDefault();
			fetchCart().then(function () { openDrawer(document.getElementById('CartDrawer')); });
			return;
		}
		var f = evt.target.closest && evt.target.closest('.js-drawer-open-collection-filters');
		if (f && document.getElementById('FilterDrawer')) {
			evt.preventDefault();
			openDrawer(document.getElementById('FilterDrawer'));
			return;
		}
		var c = evt.target.closest && evt.target.closest('.js-drawer-close');
		if (c) {
			evt.preventDefault();
			closeDrawers();
			return;
		}
		var rm = evt.target.closest && evt.target.closest('[data-cart-remove]');
		if (rm) {
			evt.preventDefault();
			changeCartLine(parseInt(rm.getAttribute('data-cart-line'), 10), 0);
		}
	});

	document.addEventListener('keyup', function (evt) {
		if (evt.key === 'Escape') closeDrawers();
	});

	document.addEventListener('change', function (evt) {
		var input = evt.target;
		if (!input.matches || !input.matches('.js-qty__num[data-cart-line]')) return;
		var qty = Math.max(0, parseInt(input.value || '0', 10));
		changeCartLine(parseInt(input.getAttribute('data-cart-line'), 10), qty);
	});

	document.addEventListener('submit', function (evt) {
		var form = evt.target;
		if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
		if (!document.getElementById('CartDrawer')) return;

		evt.preventDefault();
		var btn = form.querySelector('[data-add-to-cart]');
		if (btn) btn.setAttribute('disabled', 'disabled');

		var data = new FormData(form);
		fetch(window.Shopify.routes.root + 'cart/add.js', {
			method: 'POST',
			headers: { Accept: 'application/json' },
			body: data
		})
			.then(function (r) {
				return r.json().then(function (body) {
					return { ok: r.ok, body: body };
				});
			})
			.then(function (res) {
				if (!res.ok) throw new Error(res.body.description || res.body.message);
				return fetchCart().then(function () {
					openDrawer(document.getElementById('CartDrawer'));
				});
			})
			.catch(function (err) {
				var msg = form.querySelector('[data-cart-error]');
				if (msg) {
					msg.textContent = err.message;
					msg.classList.remove('hide');
				} else {
					window.location.href = window.Shopify.routes.root + 'cart';
				}
			})
			.then(function () {
				if (btn) btn.removeAttribute('disabled');
			});
	});

	function initProductSlideshows(scope) {
		if (!window.jQuery || !jQuery.fn.slick) return;
		jQuery('[data-product-photos]', scope || document).not('.slick-initialized').each(function () {
			var $main = jQuery(this);
			var container = this.closest('.product__photos') || document;
			$main.slick({
				fade: true,
				arrows: false,
				dots: false,
				adaptiveHeight: true,
				draggable: true,
				swipe: true
			});
			function scrollThumbIntoView(el) {
				var scroller = container.querySelector('.product__thumbs--scroller');
				if (!scroller || !el) return;
				var item = el.closest('.product__thumb-item') || el;
				if (scroller.scrollWidth > scroller.clientWidth + 1) {
					scroller.scrollTo({
						left: Math.max(0, item.offsetLeft - (scroller.clientWidth - item.offsetWidth) / 2),
						behavior: 'smooth'
					});
				} else if (scroller.scrollHeight > scroller.clientHeight + 1) {
					scroller.scrollTo({
						top: Math.max(0, item.offsetTop - (scroller.clientHeight - item.offsetHeight) / 2),
						behavior: 'smooth'
					});
				}
			}

			function activate(idx) {
				var anchors = container.querySelectorAll('[data-product-thumb]');
				var active = null;
				for (var i = 0; i < anchors.length; i++) {
					var on = String(anchors[i].getAttribute('data-index')) === String(idx);
					anchors[i].classList.toggle('is-active', on);
					var item = anchors[i].closest('.product__thumb-item');
					if (item) item.classList.toggle('is-active', on);
					if (on) active = anchors[i];
				}
				if (active) scrollThumbIntoView(active);
				syncSlideVideos(container, idx);
			}

			activate(0);
			$main.on('afterChange', function (e, slick, idx) { activate(idx); });
			jQuery(container).on('click', '[data-product-thumb]', function (e) {
				e.preventDefault();
				var idx = this.getAttribute('data-index');
				if (idx === null) {
					var item = this.closest('.product__thumb-item');
					idx = item && item.getAttribute('data-index');
				}
				if (idx !== null) $main.slick('slickGoTo', parseInt(idx, 10));
			});
			jQuery(container).on('click', '.product__thumb-arrow', function (e) {
				e.preventDefault();
				var scroller = container.querySelector('.product__thumbs--scroller');
				if (!scroller) return;
				var dir = this.classList.contains('product__thumb-arrow--prev') ? -1 : 1;
				scroller.scrollBy({ left: dir * 240, behavior: 'smooth' });
			});
			this.__sanGoToMedia = function (media) {
				if (!media) return;
				var slides = $main[0].querySelectorAll('.product-main-slide');
				for (var i = 0; i < slides.length; i++) {
					var m = slides[i].querySelector('[data-media-id]');
					if (m && String(m.getAttribute('data-media-id')) === String(media.id)) {
						$main.slick('slickGoTo', parseInt(slides[i].getAttribute('data-index'), 10));
						return;
					}
				}
				if (media.position) {
					var idx = parseInt(media.position, 10) - 1;
					if (idx >= 0 && idx < slides.length) $main.slick('slickGoTo', idx);
				}
			};
		});
	}

	theme.initProductSlideshows = initProductSlideshows;

	document.addEventListener('variantChange', function (evt) {
		var variant = evt.detail && evt.detail.variant;
		if (!variant || !variant.featured_media) return;
		var photos = document.querySelectorAll('[data-product-photos]');
		for (var i = 0; i < photos.length; i++) {
			if (photos[i].__sanGoToMedia) photos[i].__sanGoToMedia(variant.featured_media);
		}
	});

	document.addEventListener('click', function (evt) {
		var counter = evt.target.closest && evt.target.closest('.product__media-counter');
		if (counter) {
			evt.preventDefault();
			var scope = counter.closest('.product__main-photos') || document;
			var modal = scope.querySelector('.product__media-thumbs-modal');
			if (modal) modal.classList.add('is-active');
			return;
		}
		var close = evt.target.closest && evt.target.closest('.product__media-thumbs-close');
		if (close) {
			evt.preventDefault();
			var m = close.closest('.product__media-thumbs-modal');
			if (m) m.classList.remove('is-active');
			return;
		}
		if (evt.target.classList && evt.target.classList.contains('product__media-thumbs-modal')) {
			evt.target.classList.remove('is-active');
		}
	});

	document.addEventListener('keyup', function (evt) {
		if (evt.key !== 'Escape') return;
		var open = document.querySelectorAll('.product__media-thumbs-modal.is-active');
		for (var i = 0; i < open.length; i++) open[i].classList.remove('is-active');
	});

	function initRecommendations() {
		var wraps = document.querySelectorAll('[data-section-type="product-recommendations"][data-url]');
		for (var i = 0; i < wraps.length; i++) {
			(function (el) {
				if (el.__sanRecLoaded) return;
				el.__sanRecLoaded = true;
				if (el.getAttribute('data-enable') === 'false') return;
				var url = el.getAttribute('data-url') +
					'?section_id=product-recommendations' +
					'&limit=' + (el.getAttribute('data-limit') || 4) +
					'&product_id=' + el.getAttribute('data-product-id');
				fetch(url)
					.then(function (r) { return r.text(); })
					.then(function (html) {
						var div = document.createElement('div');
						div.innerHTML = html;
						var fresh = div.querySelector('[data-section-type="product-recommendations"]');
						if (fresh && fresh.innerHTML.trim().length) {
							el.innerHTML = fresh.innerHTML;
							if (window.AOS) AOS.refreshHard();
						} else {
							var sec = el.closest('.shopify-section');
							if (sec) sec.style.display = 'none';
						}
					})
					.catch(function () {});
			})(wraps[i]);
		}
	}

	document.addEventListener('click', function (evt) {
		var btn = evt.target.closest && evt.target.closest('[data-qty-adjust]');
		if (!btn) return;
		evt.preventDefault();
		var wrap = btn.closest('.js-qty__wrapper, .quantity, [data-quantity-wrapper]');
		if (!wrap) return;
		var input = wrap.querySelector('input[type="number"], .js-qty__num');
		if (!input) return;
		var min = parseInt(input.getAttribute('min') || '1', 10);
		var val = parseInt(input.value || min, 10);
		val = btn.hasAttribute('data-qty-plus') ? val + 1 : val - 1;
		input.value = Math.max(min, val);
		input.dispatchEvent(new Event('change', { bubbles: true }));
	});

	document.addEventListener('click', function (evt) {
		var trigger = evt.target.closest && evt.target.closest('[data-tool-tip-trigger]');
		var modal = document.querySelector('[data-tool-tip]');
		if (trigger && modal) {
			evt.preventDefault();
			var content = modal.querySelector('[data-tool-tip-content]');
			if (content) content.innerHTML = trigger.getAttribute('data-tool-tip-content') || '';
			modal.classList.add('is-active');
			return;
		}
		if (modal && modal.classList.contains('is-active')) {
			if (evt.target.closest('[data-tool-tip-close]') || evt.target === modal) {
				modal.classList.remove('is-active');
			}
		}
	});

	document.addEventListener('click', function (evt) {
		var head = evt.target.closest && evt.target.closest('[data-accordion-toggle]');
		if (!head) return;
		evt.preventDefault();
		var box = head.closest('[data-accordion]');
		var panel = null;
		var controls = head.getAttribute('aria-controls');
		if (controls) panel = document.getElementById(controls);
		if (!panel && box) panel = box.querySelector('[data-accordion-panel]');
		if (!panel) return;
		var open = head.getAttribute('aria-expanded') !== 'true';
		head.setAttribute('aria-expanded', open ? 'true' : 'false');
		panel.classList.toggle('is-open', open);
		if (box) box.classList.toggle('is-open', open);
	});

	document.addEventListener('click', function (evt) {
		var trigger = evt.target.closest && evt.target.closest('.collapsible-trigger');
		if (!trigger) return;
		var target = null;
		var controls = trigger.getAttribute('aria-controls');
		if (controls) target = document.getElementById(controls);
		if (!target) {
			var el = trigger.nextElementSibling;
			while (el && !el.classList.contains('collapsible-content')) el = el.nextElementSibling;
			target = el;
		}
		if (!target) return;
		evt.preventDefault();
		var open = trigger.classList.toggle('is-open');
		target.classList.toggle('is-open', open);
		trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
	});

	document.addEventListener('click', function (evt) {
		var opener = evt.target.closest && evt.target.closest('[class*="js-modal-open-"]');
		if (opener) {
			var cls = Array.from(opener.classList).find(function (c) {
				return c.indexOf('js-modal-open-') === 0;
			});
			var name = cls && cls.replace('js-modal-open-', '');
			var modal = name && (document.getElementById(name) || document.querySelector('[data-modal-id="' + name + '"], .modal--' + name));
			if (modal) {
				evt.preventDefault();
				modal.classList.add('modal--is-active');
				document.documentElement.classList.add('modal-open');
			}
			return;
		}
		var closer = evt.target.closest && evt.target.closest('.js-modal-close, .modal__close');
		if (closer) {
			var m = closer.closest('.modal, .newsletter-popup');
			if (m) {
				m.classList.remove('modal--is-active');
				document.documentElement.classList.remove('modal-open');
			}
			return;
		}
		var overlay = evt.target.classList && evt.target.classList.contains('modal') && evt.target;
		if (overlay && overlay.classList.contains('modal--is-active')) {
			overlay.classList.remove('modal--is-active');
			document.documentElement.classList.remove('modal-open');
		}
	});

	document.addEventListener('click', function (evt) {
		var toggle = evt.target.closest && evt.target.closest('.disclosure__toggle');
		var lists = document.querySelectorAll('.disclosure-list--visible');
		if (toggle) {
			evt.preventDefault();
			var parent = toggle.closest('.multi-selectors__item, [data-disclosure]') || toggle.parentNode;
			var list = parent.querySelector('.disclosure-list');
			for (var i = 0; i < lists.length; i++) {
				if (lists[i] !== list) lists[i].classList.remove('disclosure-list--visible');
			}
			if (list) list.classList.toggle('disclosure-list--visible');
			return;
		}
		if (!evt.target.closest || !evt.target.closest('.disclosure-list')) {
			for (var j = 0; j < lists.length; j++) lists[j].classList.remove('disclosure-list--visible');
		}
	});

	function initProducts(scope) {
		var root = scope || document;
		var containers = root.querySelectorAll('[data-section-type="product"], [data-product-container], .product-single');
		for (var i = 0; i < containers.length; i++) {
			if (containers[i].__sanProduct) continue;
			containers[i].__sanProduct = new ProductSection(containers[i]);
		}
		if (!containers.length && root.querySelector('[data-variant-json]')) {
			var fallback = root.querySelector('[data-variant-json]').closest('section, div');
			if (fallback && !fallback.__sanProduct) fallback.__sanProduct = new ProductSection(fallback);
		}
	}

	theme.initProducts = initProducts;

	function photoswipeItems(scope) {
		var imgs = (scope || document).querySelectorAll('[data-photoswipe-src]');
		var items = [];
		for (var i = 0; i < imgs.length; i++) {
			var src = imgs[i].getAttribute('data-photoswipe-src');
			if (!src) continue;
			if (src.indexOf('//') === 0) src = window.location.protocol + src;
			items.push({
				src: src,
				w: parseInt(imgs[i].getAttribute('data-photoswipe-width'), 10) || 1200,
				h: parseInt(imgs[i].getAttribute('data-photoswipe-height'), 10) || 1200,
				msrc: imgs[i].currentSrc || imgs[i].src || undefined
			});
		}
		return items;
	}

	var activeGallery = null;
	var pswpHideTimer = null;

	function pswpShow(el) {
		clearTimeout(pswpHideTimer);
		el.style.display = 'block';
	}

	function pswpHide(el) {
		clearTimeout(pswpHideTimer);
		el.style.display = 'none';
	}

	function openPhotoswipe(index, scope) {
		if (!window.PhotoSwipe) return false;
		var el = document.querySelector('.pswp');
		if (!el) return false;
		var items = photoswipeItems(scope);
		if (!items.length) return false;
		var idx = Math.max(0, Math.min(parseInt(index, 10) || 0, items.length - 1));
		var sources = (scope || document).querySelectorAll('[data-photoswipe-src]');

		pswpShow(el);

		var gallery = new window.PhotoSwipe(el, false, items, {
			index: idx,
			bgOpacity: 1,
			closeOnScroll: false,
			closeOnVerticalDrag: true,
			history: false,
			tapToClose: true,
			showHideOpacity: true,
			getThumbBoundsFn: function (i) {
				var img = sources[i];
				if (!img) return false;
				var rect = img.getBoundingClientRect();
				if (!rect.width || !rect.height) return false;
				var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
				return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
			}
		});

		var ui = el.querySelector('.pswp__ui');
		if (ui) ui.classList.remove('pswp__ui--hidden');
		var counter = el.querySelector('.pswp__counter');
		var thumbsModal = el.querySelector('.pswp__thumbs-modal');
		var thumbsList = el.querySelector('.pswp__thumbs-list');

		if (thumbsList) {
			var html = '';
			for (var t = 0; t < items.length; t++) {
				html += '<button type="button" class="pswp__thumb" data-pswp-thumb="' + t + '">' +
					'<img src="' + (items[t].msrc || items[t].src) + '" alt=""></button>';
			}
			thumbsList.innerHTML = html;
		}

		function sync() {
			var i = gallery.getCurrentIndex();
			if (counter) counter.textContent = i + 1 + ' / ' + items.length;
			var thumbs = el.querySelectorAll('.pswp__thumb');
			for (var k = 0; k < thumbs.length; k++) {
				thumbs[k].classList.toggle('is-active', k === i);
			}
		}

		function closeThumbs() {
			if (thumbsModal) {
				thumbsModal.style.transition = 'none';
				void thumbsModal.offsetWidth;
				thumbsModal.classList.remove('is-active');
				void thumbsModal.offsetWidth;
				thumbsModal.style.transition = '';
			}
			el.classList.remove('pswp--thumbs-open');
			if (counter) counter.setAttribute('aria-expanded', 'false');
		}

		gallery.listen('afterChange', sync);

		gallery.listen('close', function () {
			clearTimeout(pswpHideTimer);
			pswpHideTimer = setTimeout(function () { pswpHide(el); }, 600);
		});

		gallery.listen('destroy', function () {
			closeThumbs();
			if (ui) ui.classList.add('pswp__ui--hidden');
			activeGallery = null;
			pswpHide(el);
		});

		gallery.init();
		sync();
		activeGallery = gallery;
		activeGallery.__closeThumbs = closeThumbs;
		return true;
	}

	document.addEventListener('click', function (evt) {
		if (!activeGallery) return;
		var el = document.querySelector('.pswp');
		if (!el) return;

		if (evt.target.closest('.pswp__button--arrow--left')) { evt.preventDefault(); activeGallery.prev(); return; }
		if (evt.target.closest('.pswp__button--arrow--right')) { evt.preventDefault(); activeGallery.next(); return; }
		if (evt.target.closest('.pswp__button--close')) { evt.preventDefault(); activeGallery.close(); return; }

		if (evt.target.closest('.pswp__counter')) {
			evt.preventDefault();
			var modal = el.querySelector('.pswp__thumbs-modal');
			if (modal) {
				modal.style.transition = 'none';
				void modal.offsetWidth;
				modal.classList.add('is-active');
				void modal.offsetWidth;
				modal.style.transition = '';
			}
			el.classList.add('pswp--thumbs-open');
			evt.target.closest('.pswp__counter').setAttribute('aria-expanded', 'true');
			return;
		}

		if (evt.target.closest('.pswp__thumbs-close')) {
			evt.preventDefault();
			if (activeGallery.__closeThumbs) activeGallery.__closeThumbs();
			return;
		}

		var thumb = evt.target.closest('.pswp__thumb');
		if (thumb) {
			evt.preventDefault();
			activeGallery.goTo(parseInt(thumb.getAttribute('data-pswp-thumb'), 10) || 0);
			if (activeGallery.__closeThumbs) activeGallery.__closeThumbs();
			return;
		}

		var modalBg = evt.target.classList && evt.target.classList.contains('pswp__thumbs-modal');
		if (modalBg && activeGallery.__closeThumbs) activeGallery.__closeThumbs();
	});

	document.addEventListener('keydown', function (evt) {
		if (!activeGallery) return;
		if (evt.key === 'Escape') {
			var el = document.querySelector('.pswp');
			if (el && el.classList.contains('pswp--thumbs-open')) {
				if (activeGallery.__closeThumbs) activeGallery.__closeThumbs();
			} else {
				activeGallery.close();
			}
			return;
		}
		if (evt.key === 'ArrowLeft') activeGallery.prev();
		if (evt.key === 'ArrowRight') activeGallery.next();
	});

	theme.openPhotoswipe = openPhotoswipe;

	document.addEventListener('click', function (evt) {
		var zoom = evt.target.closest && evt.target.closest('.js-photoswipe__zoom, .product__photo-zoom');
		if (zoom) {
			var slide = zoom.closest('.product-main-slide');
			var scope = zoom.closest('.product__photos') || document;
			var idx = 0;
			if (slide) idx = parseInt(slide.getAttribute('data-index'), 10) || 0;
			if (openPhotoswipe(idx, scope)) evt.preventDefault();
			return;
		}
		var mediaThumb = evt.target.closest && evt.target.closest('[data-product-media-thumb]');
		if (mediaThumb) {
			evt.preventDefault();
			var modal = mediaThumb.closest('.product__media-thumbs-modal');
			var host = (modal && modal.closest('.product__main-photos')) || document;
			var srcIdx = parseInt(mediaThumb.getAttribute('data-source-index'), 10) || 0;
			if (modal) modal.classList.remove('is-active');
			openPhotoswipe(srcIdx, host.closest('.product__photos') || document);
		}
	});

	var nativeHls = /^((?!chrome|android|crios|fxios|edg).)*safari/i.test(navigator.userAgent);

	function initProductVideos(scope) {
		var vids = (scope || document).querySelectorAll('video[data-video-style]');
		for (var i = 0; i < vids.length; i++) {
			var v = vids[i];
			if (v.__sanVideoInit) continue;
			v.__sanVideoInit = true;

			if (!nativeHls) {
				var srcs = v.querySelectorAll('source');
				var hasMp4 = false;
				for (var m = 0; m < srcs.length; m++) {
					if ((srcs[m].getAttribute('type') || '').indexOf('mp4') !== -1) hasMp4 = true;
				}
				if (hasMp4) {
					var removed = false;
					for (var n = srcs.length - 1; n >= 0; n--) {
						var st = srcs[n].getAttribute('type') || '';
						var su = srcs[n].getAttribute('src') || '';
						if (/mpegurl/i.test(st) || /\.m3u8/i.test(su)) { srcs[n].remove(); removed = true; }
					}
					if (removed) v.load();
				}
			}

			if (v.getAttribute('data-video-style') === 'muted') {
				v.muted = true;
				v.loop = true;
				v.playsInline = true;
				v.setAttribute('muted', '');
				v.setAttribute('playsinline', '');
				v.setAttribute('autoplay', '');
				var pr = v.play();
				if (pr && pr.catch) pr.catch(function () {});
			} else {
				v.setAttribute('controls', 'controls');
			}
		}
	}

	theme.initProductVideos = initProductVideos;

	function syncSlideVideos(container, idx) {
		var slides = container.querySelectorAll('.product-main-slide');
		for (var i = 0; i < slides.length; i++) {
			var v = slides[i].querySelector('video');
			if (!v) continue;
			if (i === idx) {
				if (v.getAttribute('data-video-style') === 'muted') {
					var p = v.play();
					if (p && p.catch) p.catch(function () {});
				}
			} else if (!v.paused) {
				v.pause();
			}
		}
	}

	function applySort(value) {
		var url = new URL(window.location.href);
		url.searchParams.set('sort_by', value);
		url.searchParams.delete('page');
		window.location.href = url.toString();
	}

	function applyFilters(form) {
		var url = new URL(window.location.href);
		var keys = [];
		url.searchParams.forEach(function (v, k) { if (k.indexOf('filter.') === 0) keys.push(k); });
		for (var k = 0; k < keys.length; k++) url.searchParams.delete(keys[k]);

		var inputs = form.querySelectorAll('input[name], select[name]');
		for (var i = 0; i < inputs.length; i++) {
			var el = inputs[i];
			if (!el.name || el.name.indexOf('filter.') !== 0) continue;
			if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) continue;
			if (el.value === '' || el.value == null) continue;
			if (el.classList.contains('price-range__input')) {
				var range = el.closest('.price-range');
				if (range) {
					var bound = el.classList.contains('price-range__input-min')
						? range.getAttribute('data-min')
						: range.getAttribute('data-max');
					var norm = function (x) { return parseFloat(String(x).replace(/[^0-9.]/g, '')) || 0; };
					if (norm(el.value) === norm(bound)) continue;
				}
			}
			url.searchParams.append(el.name, el.value);
		}
		url.searchParams.delete('page');
		window.location.href = url.toString();
	}

	document.addEventListener('change', function (evt) {
		var el = evt.target;
		if (!el || !el.closest) return;
		if (el.id === 'SortBy' || el.name === 'SortBy' || el.name === 'sort_by') {
			evt.preventDefault();
			applySort(el.value);
			return;
		}
		var form = el.closest('.filter-form');
		if (form && el.name && el.name.indexOf('filter.') === 0) {
			applyFilters(form);
		}
	});

	function initPriceRanges(scope) {
		if (!window.noUiSlider) return;
		var ranges = (scope || document).querySelectorAll('.price-range');
		for (var i = 0; i < ranges.length; i++) {
			(function (range) {
				var slider = range.querySelector('.price-range__slider');
				if (!slider || slider.noUiSlider) return;
				var num = function (v) { return parseFloat(String(v).replace(/[^0-9.]/g, '')) || 0; };
				var min = num(range.getAttribute('data-min'));
				var max = num(range.getAttribute('data-max'));
				var from = num(range.getAttribute('data-min-value')) || min;
				var to = num(range.getAttribute('data-max-value')) || max;
				if (max <= min) return;
				var inputMin = range.querySelector('.price-range__input-min');
				var inputMax = range.querySelector('.price-range__input-max');
				var dispMin = range.querySelector('.price-range__display-min');
				var dispMax = range.querySelector('.price-range__display-max');
				var fmt = function (v) { return formatMoney(Math.round(v) * 100); };

				window.noUiSlider.create(slider, {
					start: [from, to],
					connect: true,
					step: 1,
					range: { min: min, max: max }
				});

				slider.noUiSlider.on('update', function (values) {
					if (dispMin) dispMin.textContent = fmt(values[0]);
					if (dispMax) dispMax.textContent = fmt(values[1]);
					if (inputMin) inputMin.value = Math.round(values[0]);
					if (inputMax) inputMax.value = Math.round(values[1]);
				});

				slider.noUiSlider.on('change', function () {
					var form = range.closest('form');
					if (form) form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
				});
			})(ranges[i]);
		}
	}

	theme.initPriceRanges = initPriceRanges;

	function initHeroSliders(scope) {
		var heroes = (scope || document).querySelectorAll('[data-san-hero]');
		for (var i = 0; i < heroes.length; i++) {
			(function (hero) {
				if (hero.__sanHero) return;
				hero.__sanHero = true;
				var cells = hero.querySelectorAll('.san-hero__cell');
				if (cells.length < 2) return;
				var dots = hero.querySelectorAll('[data-san-hero-go]');
				var at = 0;
				var timer = null;

				function show(n) {
					at = (n + cells.length) % cells.length;
					for (var k = 0; k < cells.length; k++) cells[k].classList.toggle('is-active', k === at);
					for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('is-active', d === at);
				}

				function play() {
					if (hero.getAttribute('data-autoplay') !== 'true') return;
					clearInterval(timer);
					var ms = parseInt(hero.getAttribute('data-speed'), 10) || 6000;
					timer = setInterval(function () { show(at + 1); }, ms);
				}

				hero.addEventListener('click', function (e) {
					var go = e.target.closest('[data-san-hero-go]');
					if (!go) return;
					show(parseInt(go.getAttribute('data-san-hero-go'), 10) || 0);
					play();
				});

				show(0);
				play();
			})(heroes[i]);
		}
	}

	theme.initHeroSliders = initHeroSliders;

	function boot() {
		if (window.AOS && typeof window.AOS.init === 'function') {
			window.AOS.init({ once: true, duration: 600, offset: 60 });
		}
		initProducts(document);
		initProductSlideshows(document);
		initRecommendations();
		initPriceRanges(document);
		initProductVideos(document);
		initHeroSliders(document);
		fetchCart().catch(function () {});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', boot);
	} else {
		boot();
	}

	document.addEventListener('shopify:section:load', function (evt) {
		initProducts(evt.target);
		initProductSlideshows(evt.target);
		initRecommendations();
		initPriceRanges(evt.target);
		initProductVideos(evt.target);
		initHeroSliders(evt.target);
		if (window.AOS && typeof window.AOS.refresh === 'function') window.AOS.refresh();
	});
})();
